export default __webpack_public_path__ + "static/media/application-endpoint.b99c30d8.svg";